import { useState } from "react";
import { api } from "../../../../../utility/api";
import { transformRecepcion } from "../helpers/data";

const transformTrasladoDetalle = (response) => {
    return {
        ...response,
        detalles: response.detalles.map((detalle) =>
            transformRecepcion(detalle),
        ),
    };
};

export const TrasladosApi = () => {
    const [cargando, setCargando] = useState(false);

    const getTrasladoDetalle = async (id) => {
        try {
            setCargando(true);
            const response = await api.get(`traslados/${id}`);
            return transformTrasladoDetalle(response);
        } catch (error) {
            console.error(error);
            throw error;
        } finally {
            setCargando(false);
        }
    };

    return {
        getTrasladoDetalle,
        cargando,
    };
};
